
interface SlideContentProps {
  slide: {
    id: number;
    title: string;
    type: string;
  };
  currentSlide: number;
}

export default function SlideContent({ slide, currentSlide }: SlideContentProps) {
  if (currentSlide === 0) return null; // Hero页面单独处理

  const renderSlideContent = () => {
    switch (slide.type) {
      case 'agenda':
        return (
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">演讲议程</h2>
              <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-6 bg-gradient-to-r from-red-50 to-red-100 rounded-lg border-l-4 border-red-500">
                  <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">当前外贸财税环境的深刻变化</h3>
                    <p className="text-gray-600 text-sm">（Why？）</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 p-6 bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg border-l-4 border-orange-500">
                  <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">五类核心客户画像与痛点深度剖析</h3>
                    <p className="text-gray-600 text-sm">（Who？）</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 p-6 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg border-l-4 border-blue-500">
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">三大合规工具解析</h3>
                    <p className="text-gray-600 text-sm">0110 vs 1039 vs 香港转口（What？）</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-6 bg-gradient-to-r from-green-50 to-green-100 rounded-lg border-l-4 border-green-500">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">分客户定制化解决方案与案例</h3>
                    <p className="text-gray-600 text-sm">（How？）</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 p-6 bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg border-l-4 border-purple-500">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">5</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">2025关键风险预警与落地行动建议</h3>
                    <p className="text-gray-600 text-sm">（Action！）</p>
                  </div>
                </div>
                
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-6 text-center">
                  <i className="ri-time-line text-3xl text-gray-600 mb-3"></i>
                  <p className="text-gray-700 font-medium">预计演讲时间：45-60分钟</p>
                  <p className="text-gray-500 text-sm mt-2">包含Q&A环节</p>
                </div>
              </div>
            </div>
          </div>
        );
        
      case 'situation':
        return (
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">第一部分：形势迫人——2025外贸财税监管新环境</h2>
              <div className="bg-red-100 border border-red-300 rounded-lg p-4 inline-block">
                <p className="text-red-800 font-semibold text-lg">核心观点：合规不再是选择，而是生存的必选项。</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              <div>
                <img 
                  src="https://public.readdy.ai/ai/img_res/01453f1f84d00788ac0e8878bb867e98.jpg"
                  alt="税务监管环境"
                  className="w-full h-64 object-cover rounded-lg shadow-md"
                />
              </div>
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-lg border-l-4 border-blue-500">
                  <div className="flex items-center mb-3">
                    <i className="ri-database-2-line text-2xl text-blue-600 mr-3"></i>
                    <h3 className="text-xl font-bold text-gray-900">数据透明化</h3>
                  </div>
                  <p className="text-gray-700">《互联网平台企业涉税信息报送规定》——平台数据直连税务局，私户收款无处遁形。</p>
                </div>
                
                <div className="bg-gradient-to-r from-orange-50 to-orange-100 p-6 rounded-lg border-l-4 border-orange-500">
                  <div className="flex items-center mb-3">
                    <i className="ri-search-eye-line text-2xl text-orange-600 mr-3"></i>
                    <h3 className="text-xl font-bold text-gray-900">监管精准化</h3>
                  </div>
                  <p className="text-gray-700">出口代理责任明晰，报关、收汇、申报数据交叉比对。</p>
                </div>
                
                <div className="bg-gradient-to-r from-green-50 to-green-100 p-6 rounded-lg border-l-4 border-green-500">
                  <div className="flex items-center mb-3">
                    <i className="ri-shield-check-line text-2xl text-green-600 mr-3"></i>
                    <h3 className="text-xl font-bold text-gray-900">政策规范化</h3>
                  </div>
                  <p className="text-gray-700">税收洼地风险升级，出口退税申报期限缩短（36个月）。</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">结论</h3>
              <p className="text-xl">传统模式崩塌，必须构建与之匹配的新财税模式。</p>
            </div>
          </div>
        );
        
      case 'customers':
        return (
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">第二部分：知己知彼——五类客户画像与核心痛点</h2>
              <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
            </div>
            
            <div className="space-y-8">
              {[
                {
                  icon: 'ri-building-2-line',
                  color: 'blue',
                  title: '阿里巴巴国际站B2B电商',
                  features: '大额订单',
                  pain: '无票采购、资金回流难',
                  image: 'https://readdy.ai/api/search-image?query=Professional%20B2B%20e-commerce%20office%2C%20alibaba%20international%20station%20interface%2C%20large%20trade%20orders%2C%20business%20people%20working%20on%20computers%2C%20modern%20office%20environment%2C%20professional%20atmosphere%2C%20blue%20corporate%20colors&width=400&height=250&seq=customer1&orientation=landscape'
                },
                {
                  icon: 'ri-amazon-line',
                  color: 'orange',
                  title: '亚马逊精品电商',
                  features: '品牌利润高',
                  pain: '关税壁垒、利润回流税负高',
                  image: 'https://readdy.ai/api/search-image?query=Amazon%20FBA%20warehouse%20with%20premium%20branded%20products%2C%20high-quality%20packaging%2C%20international%20shipping%20boxes%2C%20professional%20e-commerce%20setup%2C%20orange%20and%20white%20color%20scheme%2C%20modern%20logistics%20environment&width=400&height=250&seq=customer2&orientation=landscape'
                },
                {
                  icon: 'ri-stack-line',
                  color: 'purple',
                  title: '亚马逊精品+铺货混合电商',
                  features: '业务模式复杂',
                  pain: '税务混乱、稽查风险',
                  image: 'https://readdy.ai/api/search-image?query=Complex%20e-commerce%20operation%20with%20multiple%20product%20lines%2C%20mixed%20business%20model%2C%20various%20product%20categories%2C%20organized%20warehouse%20with%20different%20sections%2C%20purple%20branding%20elements%2C%20professional%20setup&width=400&height=250&seq=customer3&orientation=landscape'
                },
                {
                  icon: 'ri-shopping-bag-line',
                  color: 'green',
                  title: '亚马逊铺货小包电商',
                  features: '海量SKU无票',
                  pain: '无法退税、个人收款风险',
                  image: 'https://readdy.ai/api/search-image?query=Small%20package%20e-commerce%20fulfillment%20center%2C%20thousands%20of%20different%20products%2C%20multiple%20SKUs%2C%20small%20parcels%20ready%20for%20shipping%2C%20green%20logistics%20theme%2C%20efficient%20packaging%20system&width=400&height=250&seq=customer4&orientation=landscape'
                },
                {
                  icon: 'ri-ship-line',
                  color: 'indigo',
                  title: '传统外贸公司',
                  features: '规范操作',
                  pain: '退税周期长、关税成本高',
                  image: 'https://readdy.ai/api/search-image?query=Traditional%20export%20trade%20company%20office%2C%20shipping%20containers%2C%20international%20trade%20documents%2C%20experienced%20business%20professionals%2C%20classic%20corporate%20environment%2C%20navy%20blue%20corporate%20colors&width=400&height=250&seq=customer5&orientation=landscape'
                }
              ].map((customer, index) => (
                <div key={index} className="flex flex-col lg:flex-row items-center space-y-6 lg:space-y-0 lg:space-x-8 p-6 bg-gray-50 rounded-xl">
                  <div className="flex-shrink-0">
                    <img 
                      src={customer.image}
                      alt={customer.title}
                      className="w-64 h-40 object-cover rounded-lg shadow-md"
                    />
                  </div>
                  
                  <div className="flex-1 space-y-4">
                    <div className="flex items-center space-x-4">
                      <div className={`w-12 h-12 bg-${customer.color}-500 rounded-full flex items-center justify-center`}>
                        <i className={`${customer.icon} text-white text-xl`}></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">{customer.title}</h3>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className={`bg-${customer.color}-50 p-4 rounded-lg border border-${customer.color}-200`}>
                        <div className="flex items-center space-x-2 mb-2">
                          <i className="ri-check-line text-green-600"></i>
                          <span className="font-semibold text-gray-900">业务特点</span>
                        </div>
                        <p className={`text-${customer.color}-800`}>{customer.features}</p>
                      </div>
                      
                      <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                        <div className="flex items-center space-x-2 mb-2">
                          <i className="ri-alert-line text-red-600"></i>
                          <span className="font-semibold text-gray-900">核心痛点</span>
                        </div>
                        <p className="text-red-800">{customer.pain}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
        
      case 'tools':
        return (
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">第三部分：利器在手——三大合规工具核心解析</h2>
              <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
            </div>
            
            <div className="overflow-x-auto">
              <table className="w-full border-collapse bg-white rounded-lg shadow-sm">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                    <th className="border border-gray-300 px-6 py-4 text-left font-semibold">特性</th>
                    <th className="border border-gray-300 px-6 py-4 text-center font-semibold">0110一般贸易出口</th>
                    <th className="border border-gray-300 px-6 py-4 text-center font-semibold">1039市场采购贸易</th>
                    <th className="border border-gray-300 px-6 py-4 text-center font-semibold">香港公司转口贸易</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-6 py-4 font-semibold bg-gray-100">核心功能</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">退税</span>
                    </td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">无票合规出口</span>
                    </td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">规避壁垒+税务筹划</span>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-6 py-4 font-semibold bg-gray-100">税务处理</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">征退环节，退增值税</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">免征增值税，所得税核定</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">优化关税，利润留存低税区</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-6 py-4 font-semibold bg-gray-100">最佳适用</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">进项发票充足</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">无票采购、小批量多批次</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">高关税、反倾销市场</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-6 py-4 font-semibold bg-gray-100">关键词</td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <div className="space-y-1">
                        <span className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs">发票</span>
                        <span className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs ml-1">退税流程</span>
                      </div>
                    </td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <div className="space-y-1">
                        <span className="bg-green-50 text-green-700 px-2 py-1 rounded text-xs">个体户</span>
                        <span className="bg-green-50 text-green-700 px-2 py-1 rounded text-xs ml-1">简化申报</span>
                        <span className="bg-green-50 text-green-700 px-2 py-1 rounded text-xs">阳光结汇</span>
                      </div>
                    </td>
                    <td className="border border-gray-300 px-6 py-4 text-center">
                      <div className="space-y-1">
                        <span className="bg-purple-50 text-purple-700 px-2 py-1 rounded text-xs">证据链</span>
                        <span className="bg-purple-50 text-purple-700 px-2 py-1 rounded text-xs ml-1">海外利得豁免</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
                <div className="flex items-center justify-center w-16 h-16 bg-blue-500 rounded-full mx-auto mb-4">
                  <i className="ri-receipt-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-center text-gray-900 mb-2">0110一般贸易</h3>
                <p className="text-center text-gray-600 text-sm">适合有完整发票链条的传统外贸企业</p>
              </div>
              
              <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-200">
                <div className="flex items-center justify-center w-16 h-16 bg-green-500 rounded-full mx-auto mb-4">
                  <i className="ri-shopping-cart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-center text-gray-900 mb-2">1039市场采购</h3>
                <p className="text-center text-gray-600 text-sm">解决无票采购和小额贸易合规问题</p>
              </div>
              
              <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200">
                <div className="flex items-center justify-center w-16 h-16 bg-purple-500 rounded-full mx-auto mb-4">
                  <i className="ri-global-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-center text-gray-900 mb-2">香港转口</h3>
                <p className="text-center text-gray-600 text-sm">优化全球税务筹划和规避贸易壁垒</p>
              </div>
            </div>
          </div>
        );
        
      default:
        return renderSolutionSlides();
    }
  };

  const renderSolutionSlides = () => {
    const solutions = {
      solution1: {
        title: '解决方案一：阿里巴巴国际站B2B电商',
        subtitle: '"双轨并行，分而治之"策略',
        color: 'blue',
        tracks: [
          {
            name: '轨道A (有票)',
            method: '0110一般贸易出口',
            result: '正常申请出口退税',
            color: 'blue'
          },
          {
            name: '轨道B (无票)',
            method: '1039市场采购贸易',
            result: '免征增值税，个体户核定征收',
            color: 'green'
          }
        ],
        value: '解决无票痛点，降低整体税负，实现资金阳光化。',
        image: 'https://readdy.ai/api/search-image?query=Dual%20track%20business%20model%20illustration%2C%20two%20parallel%20pathways%20for%20different%20business%20operations%2C%20professional%20business%20chart%20with%20arrows%20and%20flowchart%2C%20blue%20and%20green%20color%20scheme%2C%20modern%20corporate%20presentation%20style&width=800&height=400&seq=solution1&orientation=landscape'
      },
      solution2: {
        title: '解决方案二：亚马逊精品电商',
        subtitle: '"退税+筹划，内外兼修"策略',
        color: 'orange',
        description: '境内公司通过0110模式出口至香港公司，足额申请退税。香港公司接单，转口至欧美终端客户，利用香港原产地证争取优惠关税，利润留存香港。',
        value: '最大化退税，降低关税成本，优化全球利润分配。',
        image: 'https://readdy.ai/api/search-image?query=International%20business%20flow%20from%20mainland%20China%20to%20Hong%20Kong%20to%20overseas%20markets%2C%20premium%20product%20export%20strategy%2C%20global%20supply%20chain%20optimization%2C%20orange%20corporate%20theme%2C%20professional%20business%20diagram&width=800&height=400&seq=solution2&orientation=landscape'
      },
      solution3: {
        title: '解决方案三：亚马逊精品+铺货混合电商',
        subtitle: '"多主体运营，风险隔离"策略',
        color: 'purple',
        entities: [
          {
            name: '主体A (有限公司)',
            focus: '专注精品业务',
            method: '取得进项发票，走0110出口退税'
          },
          {
            name: '主体B (个体工商户)',
            focus: '专注铺货业务',
            method: '无票采购，走1039市场采购出口'
          }
        ],
        value: '业务清晰，核算分明，彻底避免税务混同风险。',
        image: 'https://readdy.ai/api/search-image?query=Multi-entity%20business%20structure%20diagram%2C%20separate%20business%20operations%20for%20different%20product%20lines%2C%20risk%20isolation%20strategy%2C%20purple%20corporate%20branding%2C%20professional%20organizational%20chart&width=800&height=400&seq=solution3&orientation=landscape'
      },
      solution4: {
        title: '解决方案四：亚马逊铺货小包电商',
        subtitle: '"1039一站式阳光化"解决方案',
        color: 'green',
        process: [
          '注册试点地个体工商户',
          '无票货物合规报关出口',
          '免征增值税',
          '享受所得税核定征收',
          '对公账户阳光收结汇'
        ],
        benefits: [
          '极致税负：综合税负可低至0.4%以下',
          '彻底合规：解决无票出口和私户收款两大原罪',
          '简便操作：简化申报，适合海量SKU'
        ],
        image: 'https://readdy.ai/api/search-image?query=Streamlined%20small%20package%20e-commerce%20solution%2C%20single%20integrated%20workflow%2C%20green%20efficiency%20theme%2C%20automated%20compliance%20system%2C%20modern%20logistics%20and%20tax%20processing&width=800&height=400&seq=solution4&orientation=landscape'
      },
      solution5: {
        title: '解决方案五：传统外贸公司',
        subtitle: '"传统升级，全球布局"策略',
        color: 'indigo',
        approach: [
          {
            level: '基础',
            description: '继续深化0110出口退税，优化内部流程，缩短退税周期'
          },
          {
            level: '升级',
            description: '引入香港公司，针对高关税市场开展转口贸易，改变"中国原产"身份，规避贸易壁垒'
          }
        ],
        value: '在保持传统优势的基础上，获得新的国际竞争力。',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20trade%20company%20modernization%2C%20global%20business%20expansion%20strategy%2C%20international%20market%20access%2C%20navy%20blue%20corporate%20theme%2C%20professional%20business%20transformation%20concept&width=800&height=400&seq=solution5&orientation=landscape'
      }
    };

    const currentSolution = solutions[slide.type as keyof typeof solutions];
    
    if (!currentSolution) return null;

    return (
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{currentSolution.title}</h2>
          <div className={`bg-${currentSolution.color}-100 border border-${currentSolution.color}-300 rounded-lg p-4 inline-block`}>
            <p className={`text-${currentSolution.color}-800 font-semibold text-xl`}>{currentSolution.subtitle}</p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div>
            <img 
              src={currentSolution.image}
              alt={currentSolution.title}
              className="w-full h-80 object-cover rounded-lg shadow-md"
            />
          </div>
          
          <div className="space-y-6">
            {slide.type === 'solution1' && currentSolution.tracks && (
              <div className="space-y-4">
                {currentSolution.tracks.map((track, index) => (
                  <div key={index} className={`bg-${track.color}-50 p-6 rounded-lg border border-${track.color}-200`}>
                    <h3 className="font-bold text-gray-900 mb-2">{track.name}</h3>
                    <p className={`text-${track.color}-800 mb-2`}>{track.method}</p>
                    <p className="text-gray-700 text-sm">→ {track.result}</p>
                  </div>
                ))}
              </div>
            )}
            
            {slide.type === 'solution2' && (
              <div className="space-y-4">
                <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                  <h3 className="font-bold text-gray-900 mb-2">对内</h3>
                  <p className="text-blue-800">境内公司通过0110模式出口至香港公司，足额申请退税。</p>
                </div>
                <div className="bg-orange-50 p-6 rounded-lg border border-orange-200">
                  <h3 className="font-bold text-gray-900 mb-2">对外</h3>
                  <p className="text-orange-800">香港公司接单，转口至欧美终端客户，利用香港原产地证争取优惠关税，利润留存香港。</p>
                </div>
              </div>
            )}
            
            {slide.type === 'solution3' && currentSolution.entities && (
              <div className="space-y-4">
                {currentSolution.entities.map((entity, index) => (
                  <div key={index} className="bg-purple-50 p-6 rounded-lg border border-purple-200">
                    <h3 className="font-bold text-gray-900 mb-2">{entity.name}</h3>
                    <p className="text-purple-800 mb-2">{entity.focus}</p>
                    <p className="text-gray-700 text-sm">→ {entity.method}</p>
                  </div>
                ))}
              </div>
            )}
            
            {slide.type === 'solution4' && (
              <div className="space-y-6">
                <div>
                  <h3 className="font-bold text-gray-900 mb-4">操作流程</h3>
                  <div className="space-y-2">
                    {currentSolution.process?.map((step, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white text-sm font-bold">
                          {index + 1}
                        </div>
                        <span className="text-gray-700">{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h3 className="font-bold text-gray-900 mb-4">核心价值</h3>
                  <div className="space-y-2">
                    {currentSolution.benefits?.map((benefit, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <i className="ri-check-line text-green-600 mt-1"></i>
                        <span className="text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            
            {slide.type === 'solution5' && currentSolution.approach && (
              <div className="space-y-4">
                {currentSolution.approach.map((item, index) => (
                  <div key={index} className="bg-indigo-50 p-6 rounded-lg border border-indigo-200">
                    <h3 className="font-bold text-gray-900 mb-2">{item.level}</h3>
                    <p className="text-indigo-800">{item.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div className={`bg-gradient-to-r from-${currentSolution.color}-600 to-${currentSolution.color}-700 text-white rounded-lg p-8 text-center`}>
          <h3 className="text-2xl font-bold mb-4">核心价值</h3>
          <p className="text-xl">{currentSolution.value}</p>
        </div>
      </div>
    );
  };

  if (slide.type === 'risks') {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">第四部分：居安思危——2025关键风险预警</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {[
            {
              title: '平台数据与税务申报不符',
              description: '2025年10月平台数据直报税务局，务必核对一致。',
              icon: 'ri-alert-line',
              color: 'red'
            },
            {
              title: '私户收款走向末路',
              description: '与平台数据透明化直接冲突，风险极高。',
              icon: 'ri-bank-card-line',
              color: 'red'
            },
            {
              title: '出口退税逾期作废',
              description: '2026年起申报期限缩至36个月，立即清理旧单。',
              icon: 'ri-time-line',
              color: 'orange'
            },
            {
              title: '香港公司操作不实',
              description: '缺乏完备"贸易证据链"，无法申请海外利得豁免。',
              icon: 'ri-shield-cross-line',
              color: 'red'
            }
          ].map((risk, index) => (
            <div key={index} className="bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500 p-6 rounded-lg">
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 bg-${risk.color}-500 rounded-full flex items-center justify-center flex-shrink-0`}>
                  <i className={`${risk.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">红色警报：{risk.title}</h3>
                  <p className="text-gray-700">{risk.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg p-8 text-center">
          <i className="ri-error-warning-line text-4xl mb-4"></i>
          <h3 className="text-2xl font-bold mb-4">风险提示</h3>
          <p className="text-xl">以上风险已经不是潜在威胁，而是即将到来的现实挑战。必须立即行动，构建合规体系。</p>
        </div>
      </div>
    );
  }

  if (slide.type === 'actions') {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">第五部分：迈向合规——落地行动建议</h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
        </div>
        
        <div className="space-y-8">
          {[
            {
              step: '第一步',
              title: '诊断定位',
              description: '梳理自身业务模式、采购发票情况、目标市场。',
              icon: 'ri-search-line',
              color: 'blue'
            },
            {
              step: '第二步',
              title: '方案设计',
              description: '匹配最适合的解决方案（0110/1039/香港公司组合）。',
              icon: 'ri-draft-line',
              color: 'green'
            },
            {
              step: '第三步',
              title: '架构搭建',
              description: '注册对应主体（个体户、香港公司等），开设银行账户。',
              icon: 'ri-building-line',
              color: 'purple'
            },
            {
              step: '第四步',
              title: '流程落地',
              description: '与报关行、税务顾问、代理服务商协作，规范操作流程。',
              icon: 'ri-workflow-line',
              color: 'orange'
            },
            {
              step: '第五步',
              title: '持续监控',
              description: '紧跟政策变化，定期进行财税健康检查。',
              icon: 'ri-eye-line',
              color: 'indigo'
            }
          ].map((action, index) => (
            <div key={index} className="flex items-start space-x-6 p-6 bg-gray-50 rounded-xl">
              <div className={`w-16 h-16 bg-${action.color}-500 rounded-full flex items-center justify-center flex-shrink-0`}>
                <i className={`${action.icon} text-white text-2xl`}></i>
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-4 mb-3">
                  <span className={`bg-${action.color}-100 text-${action.color}-800 px-3 py-1 rounded-full text-sm font-bold`}>
                    {action.step}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900">{action.title}</h3>
                </div>
                <p className="text-gray-700 text-lg">{action.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg p-8 text-center">
          <i className="ri-rocket-line text-4xl mb-4"></i>
          <h3 className="text-2xl font-bold mb-4">立即行动</h3>
          <p className="text-xl mb-6">合规转型不是一蹴而就的过程，但每一步都至关重要。现在就开始，为2025年的新政做好充分准备。</p>
          <button className="bg-white text-green-600 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            联系我们制定专属方案
          </button>
        </div>
      </div>
    );
  }

  if (slide.type === 'summary') {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">总结与Q&A</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">核心总结</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-4 p-4 bg-green-50 rounded-lg border border-green-200">
                <i className="ri-shopping-cart-line text-2xl text-green-600"></i>
                <div>
                  <span className="font-semibold text-gray-900">无票采购</span>
                  <span className="text-gray-600 ml-2">→ 1039市场采购</span>
                </div>
              </div>
              
              <div className="flex items-center space-x-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <i className="ri-receipt-line text-2xl text-blue-600"></i>
                <div>
                  <span className="font-semibold text-gray-900">有票退税</span>
                  <span className="text-gray-600 ml-2">→ 0110一般贸易</span>
                </div>
              </div>
              
              <div className="flex items-center space-x-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
                <i className="ri-global-line text-2xl text-purple-600"></i>
                <div>
                  <span className="font-semibold text-gray-900">关税壁垒/利润筹划</span>
                  <span className="text-gray-600 ml-2">→ +香港公司转口</span>
                </div>
              </div>
            </div>
            
            <div className="mt-8 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg p-6">
              <h4 className="text-lg font-bold mb-2">最终价值</h4>
              <p>实现合规化、阳光化、低成本化的高质量发展。</p>
            </div>
          </div>
          
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Professional business consultation meeting, Q&A session, business experts answering questions, modern conference room, professional presentation setup, people raising hands for questions, corporate environment&width=600&height=400&seq=summary&orientation=landscape"
              alt="Q&A环节"
              className="w-full h-64 object-cover rounded-lg shadow-md mb-6"
            />
            
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                <i className="ri-question-answer-line mr-2"></i>
                现在开始Q&A环节
              </h3>
              <p className="text-gray-700 mb-4">
                我们将针对您的具体业务场景，提供个性化的财税合规建议。请随时提出您的问题。
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600"></i>
                  <span className="text-gray-700">业务模式适配建议</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600"></i>
                  <span className="text-gray-700">税务筹划方案定制</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600"></i>
                  <span className="text-gray-700">合规风险评估</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-600"></i>
                  <span className="text-gray-700">实施路径规划</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold mb-6">联系我们</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex flex-col items-center">
              <i className="ri-phone-line text-3xl mb-3"></i>
              <p className="font-semibold">咨询热线</p>
              <p className="text-gray-300">400-123-4567</p>
            </div>
            <div className="flex flex-col items-center">
              <i className="ri-mail-line text-3xl mb-3"></i>
              <p className="font-semibold">邮箱咨询</p>
              <p className="text-gray-300">info@company.com</p>
            </div>
            <div className="flex flex-col items-center">
              <i className="ri-wechat-line text-3xl mb-3"></i>
              <p className="font-semibold">微信咨询</p>
              <p className="text-gray-300">扫码添加专属顾问</p>
            </div>
          </div>
          
          <div className="mt-8">
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap mr-4">
              <i className="ri-calendar-check-line mr-2"></i>
              预约一对一咨询
            </button>
            <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>
              下载完整方案
            </button>
          </div>
        </div>
      </div>
    );
  }

  return renderSlideContent();
}
